import { setAppBlur } from "@/services/appBlur";

// Mixin for drawer components: drives the app blur from the drawer's open
// model so it clears in sync with the drawer (not after EP's leave animation).
// The component declares which data key holds the open state via `blurModel`
// (defaults to "isVisible", falls back to "isOpen").
export default {
  data() {
    return { _blurActive: false };
  },
  computed: {
    _blurValue() {
      const key = this.$options.blurModel;
      if (key) return this[key];
      if ("isVisible" in this) return this.isVisible;
      return this.isOpen;
    },
  },
  watch: {
    _blurValue: {
      immediate: true,
      handler(open) {
        if (open && !this._blurActive) {
          this._blurActive = true;
          setAppBlur(true);
        } else if (!open && this._blurActive) {
          this._blurActive = false;
          setAppBlur(false);
        }
      },
    },
  },
  beforeUnmount() {
    if (this._blurActive) {
      this._blurActive = false;
      setAppBlur(false);
    }
  },
};
